import React, { useState, useEffect, useContext } from 'react';
import { useParams, Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import userService from '../../services/user.service';
import { AuthContext } from '../../contexts/AuthContext';
import CompanyMember from './companyMember';
import ListMembers from './lisMembers';
import { sessionService } from '../../sessionService/storage';
import { toastOptions } from '../shared/selectStyle';

const Company = () => {
    const { t } = useTranslation();
    const params = useParams();
    const { user, setUser } = useContext(AuthContext);
    const [changed, setIsChanged] = useState(false);
    const [error, setError] = useState(false);
    const [editForm, setEditForm] = useState(false);
    const [company, setCompany] = useState({
        name: '',
        creatorId: params.userId,
        _id: ''
    });

    useEffect(() => {
        if (user.companyId && user.isCompany) { getCompany(); }
    }, []);

    const getCompany = async () => {
        const response = await userService.getCompanyByCreatorId();
        setCompany(response);
        sessionService.updateUser({ ...user, code: response.code });
        setUser({ ...user, code: response.code });

    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (validateForm()) {
            const response = await userService.upadeteCompany(company);
            toast.success("Company is successfully updated!", toastOptions);
            sessionService.updateUser({ ...user, companyName: response.name });
            setUser({ ...user, companyName: response.name });
            toggleEdit(false);
        } else {
            setError(true);
        }

    }

    const handleChange = (event) => {
        setError(false);
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        setCompany({
            ...company,
            [name]: value.trim()
        });
    }

    const isChanged = () => {
        setIsChanged(!changed)
    }

    const toggleEdit = () => {
        setEditForm(editForm => !editForm)
    }

    const validateForm = () => {
        return company.name && company.name.length > 3;
    }

    return (
        <div>
            {user.isCompany || !user.companyId ?
                <div className="dashboard-view space-around">
                    <div className="company-wrapper">
                        <div>
                            {!editForm ? <h4 className="h4-title">{t('company.label.title')}</h4> : <h4 className="h4-title">{t('company.label.update')}</h4>}
                            {editForm ? <form className="form-sm edit-company-form" onSubmit={handleSubmit}>
                                {(company._id) ? <div className="close-company-form">
                                    <i className="fa fa-times-circle" aria-hidden="true" onClick={toggleEdit}></i>
                                </div> : null}
                                <div className="form-group custom-input">
                                    <label htmlFor=""> {t('company.label.name')}:</label>
                                    <input className="form-control" type="text" name="name" value={company.name} onChange={handleChange} />
                                </div>
                                {error ? <div className="message-alert"><p>{t('requiredFields.msg')}</p></div> : null}
                                <button className="btn btn-blue">{(!editForm) ? "Create company" : "Update"}</button>

                            </form> : <div className="company-header">
                                    <h4 className="h4-title">{company.name} <i className="fa fa-pencil" aria-hidden="true" onClick={toggleEdit}></i></h4>
                                    <h5 className="company-code">Company code: {company.code}</h5>
                                </div>}
                            {(user.isCompany && user.companyId && company.code) ? <CompanyMember companyId={user.companyId} code={company.code} isChanged={isChanged} /> : null}
                        </div>
                        {(user.isCompany && user.companyId) ? <div className="company-members-wrapper">
                            <ListMembers companyId={user.companyId} changed={changed} isChanged={isChanged} />
                        </div> : null}

                    </div>
                </div> : <Redirect to="/dashboard/profile" />}
        </div>
    );
}

export default Company;



// WEBPACK FOOTER //
// ./src/components/companyComponent/company.js